import { create } from "zustand";
import { persist } from "zustand/middleware";

export type PaymentItem = {
  name: string;
  priceLocal: string;
  priceUS: string;
  diamondsQuantityToEarn: number;
  img: string;
  countryCode: string;
  diamondsBalance: number;
  coinsBalance: number;
  energyBalance: number;
  hintsBalance: number;
  discount?: string | null;
};

export type CustomParameters = {
  platform: string;
  storeListingName: string;
  iapSku: string;
};

export type TAnalyticsExtra = {
  isOnSale: boolean;
  isFirstPurchase?: boolean;
  oldDiamondsQuantity: number;
  bonusPercentage: number;
  saleDiscountPercentage: number;
  context: "web_diamonds_store" | "web_store_bundles_offers" | "web_store_letters";
  gameSku?: string;
  isDirectPaymentFromApp?: boolean;
  isFromPWAWebStore?: boolean;
};

export type PaymentInfo = {
  user: { id: string };
  item: PaymentItem;
  customParameters: CustomParameters;
  currency: string;
  isSandbox: boolean;
  purchaseAmount: number;
  returnUrl: string;
};

export type PaymentState = {
  payment: PaymentInfo | null;
  setPayment: (payment: PaymentInfo) => void;
  clearPayment: () => void;
};

export const usePaymentStore = create<PaymentState>()(
  persist(
    (set) => ({
      payment: null,

      setPayment: (payment: PaymentInfo) => set({ payment }),

      clearPayment: () => set({ payment: null }),
    }),
    {
      name: "payment-storage", // Key for localStorage
    },
  ),
);

// Selectors
export const usePayment = () => usePaymentStore((state) => state.payment);
export const usePaymentUser = () => usePaymentStore((state) => state.payment?.user);
export const usePaymentItem = () => usePaymentStore((state) => state.payment?.item);
export const usePaymentCurrency = () => usePaymentStore((state) => state.payment?.currency);
